import { TransportOrder } from "@/model/transportorder/transportOrder"
import { State } from "./store"
import { createSelector } from "@reduxjs/toolkit"
import { CargoTypeFilter, getOverviewTransportOrders as filterTransportOrders } from "./transportorder.slice"

export const getOverviewTransportOrders
    = (store: State): TransportOrder[] => store.transportOrder.overviewTransportOrders

export const getCsvTransportOrders = createSelector(
    [(store: State) => store.transportOrder],
    state => filterTransportOrders(state.transportOrders, state.searchPhrase, CargoTypeFilter.ALL, state.statusFilter, state.sortCriteria)
)
